/*
 * @Descripttion:
 * @Version: 1.0.0
 * @Author: 倪国晓
 * @Date: 2022-09-01 14:40:16
 * @LastEditors: 刘帅博 liushuaibo@yangxuan.net
 * @LastEditTime: 2023-08-23 16:35:04
 */
import ColumnTypes from '@/utils/ColumnTypes';

const content = {
	key: 'content',
	label: '业务内容',
	type: 'rdText',
	minWidth: '120',
};
const from_user_name = {
	key: 'from_user_name',
	label: '被移交人',
	type: 'rdText',
	width: '150',
};
const to_user_name = {
	key: 'to_user_name',
	label: '新移交人',
	type: 'rdText',
	width: '180',
};
const operator_name = {
	key: 'operator_name',
	label: '操作人',
	type: () => import('./operator_name.vue'),
	width: '160',
};
const operations = {
	key: 'operations',
	label: '操作',
	type: ColumnTypes.ButtonsCell,
	width: '100',
	mode: 'vertical',
};
export default [content, from_user_name, to_user_name, operator_name, operations];
